import { useContext, useMemo } from 'react';

import { XYChartDataContext } from '../context/XYChartData.context.js';
import {
  AREA_VARIANT,
  type AreaSeriesToMetadata,
  type AreaSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

export interface AreaDataInternal {
  filteredSeriesWithDatapoints: AreaSeriesWithDatapoints[];
  seriesToMetadata: AreaSeriesToMetadata;
}

export const useAreaData = () => {
  const context = useContext(XYChartDataContext);

  if (context === undefined) {
    throw new Error('useAreaData must be used within a XYChartDataContext');
  }

  const filteredContext = useMemo(() => {
    return {
      seriesToMetadata: context.seriesToMetadata,
      filteredSeriesWithDatapoints: context.filteredSeriesWithDatapoints.filter(
        (series) => series.type === AREA_VARIANT,
      ),
    };
  }, [context]);

  return filteredContext as AreaDataInternal;
};
